export enum EEopTemplates {
    'REMs EOP' = 1,
    'AL EOP' = 2,
    'MS EOP' = 3,
    'GA EOP' = 4
}

export enum ESectionTypes {
    // REMS EOP
    "Core Planning Team" = 1,
    "ICS Roles" = 2,
    "Schedule" = 3,
    "Assessments" = 4,
    "Threat & Hazard" = 5,
    "Functions - Goals and Objectives" = 6,
    "Threat/Hazard - Goals and Objectives" = 7,
    "Functional Assignments" = 8,
    "Function - Courses of Action" = 9,
    "Threat/Hazard - Courses of Action" = 10,
    "Introductory Materials" = 11,
    "Purpose and Situation Overview" = 12,
    "Concept of Operations" = 13,
    "Organization and Assignment of Responsibilities" = 14,
    "Direction, Control, and Coordination" = 15,
    "Information Collection, Analysis, and Dissemination" = 16,
    "Training and Exercises" = 17,
    "Administration, Finance, and Logistics" = 18,
    "Plan Development and Maintenance" = 19,
    "Authorities and References" = 20,
    "Custom EOP Page" = 21,

    // AL EOP
    "Statement of Commitment" = 22,
    "System/School Safety Planning Team" = 23,
    "Emergency Telephone List" = 24,
    "Staff Skills Survey & Inventory" = 25,
    "Incident Command System Roles" = 26,
    "List of Materials and Equipment" = 27,
    "Basic Resources Needed" = 28,
    "Identification of Hazard (School Grounds)" = 29,
    "Identification of Hazard (Classroom)" = 30,
    "Identification of Hazard (Along Evacuation Routes)" = 31,
    "Identification of Hazard (Neighborhoods)" = 32,
    "Analysis of Identified Hazards" = 33,
    "Communication" = 34,
    "Evacuation" = 35,
    "Heightened Awareness" = 36,
    "Lockdown" = 37,
    "Secure Perimeter" = 38,
    "Secure Your Area of Responsibility" = 39,
    "Shelter In Place" = 40,
    "After School Activities" = 41,
    "Crisis Management" = 42,
    "Drills, Training, & Collaboration Reports" = 43,
    "Mandatory Training Resources" = 44,
    "Central Office EOP" = 45,
    "District Coordinator Training Log" = 46,

    // MS EOP
    "Mission Statement" = 47,
    "District Emergency Contact Information" = 48,
    "Community Emergency Contact Information" = 49,
    "Campus Emergency Response Team Contact List" = 50,
    "Evacuation Areas" = 51,
    "Reunification Plan" = 52,
    "Reunification Areas" = 53,
    "ADA/Special Needs Considerations Plan" = 54,
    "General Response Duties" = 55,
    "Fire / Explosion" = 56,
    "Fire / Explosion Near The School" = 57,
    "Severe Weather" = 58,
    "Intruder / Lockdown / Controlled Movement" = 59,
    "Earthquake" = 60,
    "Bomb Threat" = 61,
    "Gas Leak / Gas Odor" = 62,
    "Hazardous Materials" = 63,
    "After School Care" = 64,
    "Athletic Zone Plan" = 65,
    "Drill, Training, and Collaboration Reports" = 66,
    "SRO Training Resources" = 67,
    "SSO Training Resources" = 68,

    // GA EOP
    "Purpose" = 69,
    "School Leadership" = 70,
    "Incident Command System" = 71,
    "School Demographics" = 72,
    "After-Hours Contacts" = 73,
    "Administrator Names and Positions" = 74,
    "School Safety Committee" = 75,
    "Number of Student, Staff, Rooms" = 76,
    "Shelter Information" = 77,
    "Hazardous Materials in School Facility" = 78,
    "Transportation Needs" = 79,
    "Evacuation Routes, Reunification Sites, and Staging Areas" = 80,
    "Emergency Evacuation Kits" = 81,
    "Special Needs Consideration" = 82,
    "Emergency Utilities Checklist" = 83,
    "Drills" = 84,
    "CPR/First Aid/AED" = 85,
    "Security Issues in School Safety Zone" = 86,
    "School Visitors" = 87,
    "Student Sign In and Out Procedure" = 88,
    "Medications" = 89,
    "Emergency Status Cards" = 90
}

export enum ESubSectionTypes {
    "Promulgation" = 1,
    "Approval Implementation" = 2,
    "Record of Changes" = 3,
    "Record of Distribution" = 4,
    "Purpose" = 5,
    "Scope" = 6,
    "Situation Overview" = 7,
    "Planning Assumptions" = 8,
    
    //  AL EOP SubSections
    "Evacuation" = 9,
    "Evacuation - Reunification" = 10,
    "Evacuation - Recovery" = 11,
    "Lockdown" = 12,
    "Lockdown - Reunification" = 13,
    "Lockdown - Recovery" = 14,
    "Secure Perimeter" = 15,
    "Secure Perimeter - Reunification" = 16,
    "Secure Perimeter - Recovery" = 17,
    "Shelter In Place" = 18,
    "Shelter In Place - Reunification" = 19,
    "Shelter In Place - Recovery" = 20,
    "Central Office Staffs Support to Schools" = 21,
    "Managing an Event at the Central Office" = 22,
    "Recovery" = 23,
    "School to School Support" = 24
}

export enum ESectionRoutes {
    "core-planning-team" = 1,
    "nims-ics" = 2,
    "schedule" = 3,
    "assessments" = 4,
    "threats-hazards" = 5,
    "functions" = 6,
    "threats-hazards-objectives" = 7, 
    "functional-assignments" = 8, 
    "functions-courses-of-action" = 9, 
    "threats-hazards-courses-of-action" = 10,
    
    "introductory-materials" = 11,
    "purpose-situation-overview" = 12,
    "concept-of-operations" = 13,
    "organization-assignment-of-responsibilities" = 14,
    "direction-control-coordination" = 15,
    "information-collection-analysis-dissemination" = 16,
    "training-exercises" = 17,
    "administration-finance-logistics" = 18,
    "plan-development-maintenance" = 19,
    "authorities-references" = 20,
    // custom EOP page has dynamic route = 21

    // AL EOP routes
    "statement-of-commitment" = 22,
    "system-school-safety-planning-team" = 23,
    "emergency-telephone-list" = 24,
    "staff-skills-survey-inventory" = 25,
    "incident-command-system-roles" = 26,
    "list-of-materials-equipment" = 27,
    "basic-resources" = 28,
    "hazard-school-ground" = 29,
    "hazard-classroom" = 30,
    "hazard-evacuation-routes" = 31,
    "hazard-neighborhoods" = 32,
    "analysis-identified-hazards" = 33,
    "communication" = 34,
    "evacuation" = 35,
    "heightened-awareness" = 36,
    "lockdown" = 37,
    "secure-perimeter" = 38,
    "secure-area-responsibility" = 39,
    "shelter-in-place" = 40,
    "after-school-activities" = 41,
    "crisis-management" = 42,
    "drills-training-collaboration-reports" = 43,
    "mandatory-training-resources" = 44,
    "central-office-eop" = 45,
    "district-coordinator-training-log" = 46,

    // MS EOP Plans
    "mission-statement" = 47,
    "district-emergency-contact-information" = 48,
    "community-emergency-contact-information" = 49,
    "campus-emergency-response-team-contact-list" = 50,
    "evacuation-areas" = 51,
    "reunification-plan" = 52,
    "reunification-areas" = 53,
    "ada-special-needs-considerations-plan" = 54,
    "general-response-duties" = 55,
    "fire-explosion" = 56,
    "fire-explosion-near-the-school" = 57,
    "severe-weather" = 58,
    "intruder-lockdown-controlled-movement" = 59,
    "earthquake" = 60,
    "bomb-threat" = 61,
    "gas-leak-gas-odor" = 62,
    "hazardous-materials" = 63,
    "after-school-care" = 64,
    "athletic-zone-plan" = 65,
    "drill-training-and-collaboration-reports" = 66,
    "sro-training-resources" = 67,
    "sso-training-resources" = 68,

    // GA EOP routes
    "purpose" = 69,
    "school-leadership" = 70,
    "incident-command-system" = 71,
    "school-demographics" = 72,
    "after-hours-contact" = 73,
    "administrator-names-and-positions" = 74,
    "school-safety-committee" = 75,
    "number-of-student-staff-rooms" = 76,
    "shelter-information" = 77,
    "hazardous-materials-in-school-facility" = 78,
    "transportation-needs" = 79,
    "evacuation-routes-reunification-sites-and-staging-areas" = 80,
    "emergency-evacuation-kits" = 81,
    "special-needs-consideration" = 82,
    "emergency-utilities-checklist" = 83,
    "drills" = 84,
    "cpr-first-aid-aed" = 85,
    "security-issues-in-school-safety-zone" = 86,
    "school-visitors" = 87,
    "student-sign-in-and-out-procedure" = 88,
    "medications" = 89,
    "emergency-status-cards" = 90,
}

export enum EAssessmentTypes {
    "Site" = 1,                 // REMS EOP
    "Capacity" = 2,
    "Climate" = 3,
    "AL-School Grounds" = 4,       // AL EOP
    "AL-Classroom" = 5,
    "AL-Evacuation Routes" = 6,
    "AL-Neighborhoods" = 7,
    "AL-Skills Survey & Inventory" = 8,
}

export enum EAssessmentSubTypes {
    "School Grounds" = 1,                   // REMS EOP
    "Classrooms" = 2,
    "Evacuation Routes" = 3,
    "Neighborhoods and Communities" = 4,
    "Skills Survey" = 5,
    "Instructional Staff" = 6,
    "Non-Instructional Staff" = 7,
    "Parent" = 8,
    "Student" = 9,
    "AL-School Building" = 10,                  // AL EOP
    "AL-Playground" = 11,
    "AL-School Grounds" = 12,
    "AL-Other Structures" = 13,
    "AL-Classroom" = 14,
    "AL-Evacuation Routes" = 15,
    "AL-Neighborhoods" = 16,
    "AL-Skills Survey & Inventory" = 17,
}

export enum EGoalTypes {
    "Before" = 1,
    "During" = 2,
    "After" = 3
}

export enum EScheduleTypes {
    "Training" = 1,
    "Drills" = 2,
    "Meeting" = 3,
    "Crisis" = 4,
    "Collaboration" = 5
}

export enum EDrillReportTypes {
    "Drills" = 1,
    "Training" = 2,
    "Crisis" = 3,
    "Collaboration" = 4
}

export enum ECorePlanningTeamType {
    "School Safety Planning Team" = 1,
    "Emergency Telephone List" = 2,
    "District Emergency Contact Information" = 3,
    "Community Emergency Contact Information" = 4,
    "Campus Emergency Response Team Contact List" = 5,
    "School Leadership" = 6,
    "After-Hours Contacts" = 7,
    "Administrator Names and Positions" = 8,
    "School Safety Committee" = 9,
    "Reunification Team" = 10
}

export function getSectionNameFromRoute(route: string): string | undefined {
    const sectionId = ESectionRoutes[route as keyof typeof ESectionRoutes];
  
    if (!sectionId) return undefined;
    return ESectionTypes[sectionId];
  }
